import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import { AddEditCrew } from '@/modules/workforce/Crew/components/Modals/AddEditCrew';
import { Button, Typography } from '@/shared/components/atoms';
import { BaseIcon } from '@/shared/components/atoms/IconButton/BaseIcon';
import ConfirmationModal from '@/shared/components/molecules/ConfirmationModal';
import DotedMenu from '@/shared/components/molecules/DotedMenu';
import routes from '@/shared/constant/routes';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Archive from '~/images/shared/Archive.svg';
import DotsMenu from '~/images/shared/HorizontalHollowDots.svg';
import Plus from '~/images/shared/Plus.svg';

const CrewsHeader = () => {
  const { t } = useTranslation('common');
  const { push } = useRouter();
  const { openModal, closeModal } = useModal();

  return (
    <div className='mb-[16px] flex justify-between'>
      <Typography variant='h1' weight='semiBold' className='capitalize'>
        {t('Crews')}
      </Typography>
      <div className='flex items-center gap-2'>
        <Button
          onClick={() =>
            openModal(<AddEditCrew />, {
              variant: 'full',
              title: t('add-crew'),
              titleVariant: 'h6',
              onClose: () =>
                openModal(
                  <ConfirmationModal
                    header={t('going-somewhere-else')}
                    message={t('you-will-lose-all-data')}
                    variant='warning'
                    dismissText={t('continue-editing')}
                    confirmText={t('discard-and-exit')}
                    onDismissRemoveNumber={1}
                    onConfirm={closeModal}
                    buttonsAlignment='col'
                    preferredAction='dismiss'
                  />
                ),
            })
          }
          variant='filled'
          size='none'
          className='!rounded-xl'
        >
          <span className='flex items-center gap-2 p-16 text-base font-medium'>
            <BaseIcon size='sm'>
              <Plus />
            </BaseIcon>
            {t('add-crew')}
          </span>
        </Button>
        <DotedMenu
          list={[
            {
              id: '0',
              title: (
                <div className='text-1 flex items-center gap-1 text-primary-default'>
                  <Archive />
                  <span className='whitespace-nowrap'>
                    {t('inactive-crews')}
                  </span>
                </div>
              ),
              action: () => {
                push({
                  pathname: routes.inactiveLists,
                  query: {
                    list: 3,
                  },
                });
              },
            },
          ]}
          getTitle={(item) => item.title}
          getId={(item) => item?.id}
          getAction={(item) => item.action}
          onOpen={() => null}
          DotsMenuIcon={<DotsMenu className='text-24 text-primary-default' />}
        />
      </div>
    </div>
  );
};

export { CrewsHeader };
